import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { FileText } from "lucide-react";

export const PDF_CONVERTIBLE_RE = /\.(jpe?g|png|webp|gif|bmp|tiff?|docx|txt)$/i;
export const isPdf = (f) => /\.pdf$/i.test(f.name) || f.type === "application/pdf";

// Chiede, file per file, se convertire in PDF i file non-PDF prima del caricamento.
export default function ConvertPdfDialog({ files, answers, setAnswers, onConfirm, onCancel }) {
  const convertibili = files.filter((f) => !isPdf(f) && PDF_CONVERTIBLE_RE.test(f.name));
  const altri = files.filter((f) => !isPdf(f) && !PDF_CONVERTIBLE_RE.test(f.name));
  const allAnswered = convertibili.every((f) => answers[f.name + f.size] !== undefined);
  const setAll = (v) => setAnswers(Object.fromEntries(convertibili.map((f) => [f.name + f.size, v])));
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-lg" data-testid="convert-pdf-dialog">
        <DialogHeader><DialogTitle className="font-head">Conversione in PDF</DialogTitle></DialogHeader>
        <div className="space-y-2 max-h-[55vh] overflow-y-auto pr-1">
          {convertibili.map((f, i) => {
            const k = f.name + f.size, v = answers[k];
            return (
              <div key={k} className="rounded-md border border-slate-700 p-3" data-testid={`convert-pdf-item-${i}`}>
                <div className="flex items-center gap-2 text-sm font-medium text-slate-100 break-all"><FileText className="h-4 w-4 text-amber-400 shrink-0" />{f.name}</div>
                <div className="mt-2 flex items-center justify-between gap-2 flex-wrap">
                  <span className="text-xs text-slate-400">Vuoi convertire questo file in PDF?</span>
                  <div className="flex gap-1.5">
                    <button type="button" onClick={() => setAnswers((a) => ({ ...a, [k]: true }))} data-testid={`convert-pdf-yes-${i}`}
                      className={`h-8 px-4 rounded-md text-xs font-semibold border transition-colors ${v === true ? "bg-emerald-600 border-emerald-600 text-white" : "border-slate-600 text-slate-200 hover:bg-slate-800"}`}>Sì</button>
                    <button type="button" onClick={() => setAnswers((a) => ({ ...a, [k]: false }))} data-testid={`convert-pdf-no-${i}`}
                      className={`h-8 px-4 rounded-md text-xs font-semibold border transition-colors ${v === false ? "bg-slate-600 border-slate-600 text-white" : "border-slate-600 text-slate-200 hover:bg-slate-800"}`}>No</button>
                  </div>
                </div>
              </div>
            );
          })}
          {altri.length > 0 && (
            <div className="text-xs text-slate-400 rounded-md border border-slate-800 p-2.5" data-testid="convert-pdf-unsupported">
              Non convertibili, verranno caricati nel formato originale: {altri.map((f) => f.name).join(", ")}
            </div>
          )}
        </div>
        <DialogFooter className="gap-2 sm:justify-between flex-wrap">
          {convertibili.length > 1 ? (
            <div className="flex gap-2">
              <Button type="button" variant="ghost" onClick={() => setAll(true)} data-testid="convert-pdf-all-yes" className="text-xs text-slate-300">Sì a tutti</Button>
              <Button type="button" variant="ghost" onClick={() => setAll(false)} data-testid="convert-pdf-all-no" className="text-xs text-slate-300">No a tutti</Button>
            </div>
          ) : <span />}
          <div className="flex gap-2">
            <Button type="button" variant="outline" onClick={onCancel} data-testid="convert-pdf-cancel" className="border-slate-700 text-slate-200 hover:bg-slate-800">Annulla</Button>
            <Button type="button" disabled={!allAnswered} onClick={onConfirm} data-testid="convert-pdf-confirm" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">Carica</Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
